import api from "./api";

const users = "/users/users";
const user = "/users/usersbyid";
const edit = "/users/edit";
const add = "/users/add";
const del = "/users/delete=";

const getUsers = () => api.get(users);

const getUserById = (id) => api.get(`${user}/${id}`);

const editUser = (model) => api.post(edit, model);
const addUser = (model) => api.post(add, model);
const deleteUser = (id) => api.delete(del + id);

export default {
  getUsers,
  getUserById,
  editUser,
  addUser,
  deleteUser,
};
